import * as React from 'react';

import SettingsActionCreators from 'bundles/account-settings/actions/SettingsActionCreators';
import CodeConfirmationModal from 'bundles/account-settings/components/sections/two-factor/CodeConfirmationModal';
import PasswordConfirmationModal from 'bundles/account-settings/components/sections/two-factor/PasswordConfirmationModal';
import SettingsConstants from 'bundles/account-settings/constants/SettingsConstants';

import _t from 'i18n!nls/account-settings';

const { TwoFactorAuthenticationStatus } = SettingsConstants;

type Props = {
  state: string;
  qrCode?: string | null;
  invalidFields: string[];
  updating: boolean;
};

const TwoFactorAuthenticationModal = ({ state, qrCode, invalidFields, updating }: Props) => {
  if (state === TwoFactorAuthenticationStatus.ENABLING_CONFIRMING_PASSWORD) {
    return (
      <PasswordConfirmationModal
        updating={updating}
        invalidFields={invalidFields}
        submitAction={SettingsActionCreators.confirmPasswordToEnableTwoFactorAuthentication}
        title={_t('Enable Two-Factor Authentication')}
      />
    );
  } else if (state === TwoFactorAuthenticationStatus.ENABLING_CONFIRMING_CODE && qrCode) {
    return <CodeConfirmationModal updating={updating} invalidFields={invalidFields} qrCode={qrCode} />;
  } else if (state === TwoFactorAuthenticationStatus.DISABLING_CONFIRMING_PASSWORD) {
    return (
      <PasswordConfirmationModal
        updating={updating}
        invalidFields={invalidFields}
        submitAction={SettingsActionCreators.confirmPasswordToDisableTwoFactorAuthentication}
        title={_t('Disable Two-Factor Authentication')}
      />
    );
  } else {
    return <span />;
  }
};

export default TwoFactorAuthenticationModal;
